import { useEffect } from "react";
import { checkImage } from "../../utils/MainHelper";
import { useState } from "react";

import PVBLIC_ONE_Logo from "../../images/whitelabel/PVBLIC_ONE_Logo.png"

const useWhiteLabelLogo = (accountID, whiteLabelType) => {
    const [imageUrl, setImageUrl] = useState(undefined)


    useEffect(() => {
        if (whiteLabelType) {
            if (whiteLabelType.toLowerCase() === "pvblicone") {
                const imgUrl = PVBLIC_ONE_Logo
                const callback = (val) => {
                    if (val) setImageUrl(imgUrl)
                }
                checkImage(imgUrl, callback)
            } else {
                const imgUrl = `https://accountsmgr-media.s3.ap-southeast-1.amazonaws.com/accounts/${accountID}.png`
                const callback = (val) => {
                    if (val) setImageUrl(imgUrl)
                }
                checkImage(imgUrl, callback)
            }
        }
    }, [accountID, whiteLabelType])

    return imageUrl;
}

export default useWhiteLabelLogo

